import Button from "@components/Button"
import CheckboxInputButton from "@components/CheckboxInputButton"
import Layout from "@components/Layout"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Form } from "react-router-dom"

export default function GoalsPage() {
  const [selectedGoals, setSelectedGoals] = useState<string[]>([])

  const { t } = useTranslation()

  const handleCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked

    const goal = event.target.value

    if (checked) {
      setSelectedGoals([...selectedGoals, goal])
    } else {
      setSelectedGoals(
        selectedGoals.filter((selectedGoal) => selectedGoal !== goal),
      )
    }
  }

  return (
    <Layout>
      <div className="shrink-0 space-y-4">
        <h1 className="custom-heading">
          {t("pages.onboarding.goals.heading")}
        </h1>

        <h2 className="custom-subheading">
          {t("pages.onboarding.goals.subheading")}
        </h2>
      </div>

      <Form className="flex grow flex-col justify-between gap-8" method="post">
        <div className="flex grow flex-col justify-center gap-5">
          <CheckboxInputButton
            className="from-pd-orange"
            emoji="💡"
            id={t("pages.onboarding.goals.more_productive", { lng: "en" })}
            name={t("pages.onboarding.goals.heading", { lng: "en" })}
            onChange={handleCheckBoxChange}
            title={t("pages.onboarding.goals.more_productive")}
          />

          <CheckboxInputButton
            className="from-pd-yellow"
            emoji="👟"
            id={t("pages.onboarding.goals.more_active", { lng: "en" })}
            name={t("pages.onboarding.goals.heading", { lng: "en" })}
            onChange={handleCheckBoxChange}
            title={t("pages.onboarding.goals.more_active")}
          />

          <CheckboxInputButton
            className="from-pd-peach"
            emoji="🔨"
            id={t("pages.onboarding.goals.more_disciplined", { lng: "en" })}
            name={t("pages.onboarding.goals.heading", { lng: "en" })}
            onChange={handleCheckBoxChange}
            title={t("pages.onboarding.goals.more_disciplined")}
          />

          <CheckboxInputButton
            className="from-pd-purple"
            emoji="🌱"
            id={t("pages.onboarding.goals.more_mindful", { lng: "en" })}
            name={t("pages.onboarding.goals.heading", { lng: "en" })}
            onChange={handleCheckBoxChange}
            title={t("pages.onboarding.goals.more_mindful")}
          />
        </div>

        <div className="shrink-0 text-center">
          <Button
            disabled={selectedGoals.length === 0}
            iconOnly
            title={t("shared.continue")}
            type="submit"
          />
        </div>
      </Form>
    </Layout>
  )
}
